import React, { useState } from "react";
import { masking } from "../../utils/AppFunctions";
import { eyeIcon, visibilityEyeIcon } from "../../assets/icons/SvgIconList";

interface IMaskedValueProps {
  value: string;
  regex: RegExp;
  maskChar?: string;
  onlyMasked?: boolean;
}

const MaskedValue: React.FC<IMaskedValueProps> = ({
  value,
  regex,
  maskChar = "*",
  onlyMasked = false,
}) => {
  const [isMasked, setIsMasked] = useState(true);

  const maskedValue = masking(value, regex, maskChar);

  const toggleMask = () => {
    if (!onlyMasked) {
      setIsMasked(!isMasked);
    }
  };

  return (
    <div className="flex items-center">
      <div>{isMasked ? maskedValue : value}</div>
      {!onlyMasked && value ? (
        <div onClick={toggleMask} className="cursor-pointer">
          <div className="size-5 ml-2">
            {isMasked ? visibilityEyeIcon : eyeIcon}
          </div>
        </div>
      ) : (
        "-"
      )}
    </div>
  );
};

export default MaskedValue;
